import React from 'react';
import RegisterForm from "../components/RegisterForm";

function RegisterView() {
    return <RegisterForm/>
}

export default RegisterView;
